var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'quote-card',
        _vm.theme,
        {
            pc: _vm.isPc
        }
    ],style:([_vm.cssProperties])},[_c('div',{ref:"swiper",staticClass:"swiper card-list"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.list),function(stock,index){return _c('div',{key:index,staticClass:"card swiper-slide"},[_c('div',{staticClass:"name"},[_c('p',{staticClass:"text-over limit-2"},[_vm._v("\n                        "+_vm._s(stock.name)+"\n                    ")])]),_vm._v(" "),_c('p',{class:[
                        'price',
                        {
                            flat: stock.priceChange == 0,
                            up: stock.priceChange > 0,
                            down: stock.priceChange < 0
                        }
                    ]},[_vm._v("\n                    "+_vm._s(stock.price)+"\n                ")]),_vm._v(" "),_c('p',{class:[
                        'quote',
                        {
                            flat: stock.priceChange == 0,
                            up: stock.priceChange > 0,
                            down: stock.priceChange < 0
                        }
                    ]},[_c('span',{staticClass:"change"},[_vm._v(_vm._s("" + (stock.priceChange > 0 ? '+' : '') + stock.priceChange))]),_vm._v(" "),_c('span',{staticClass:"radio"},[_vm._v(_vm._s("" + (stock.priceChange > 0 ? '+' : '') + stock.ratioPriceChange))])]),_vm._v(" "),(_vm.chartDatas[stock.stockId])?_c('SparkChart',{staticClass:"chart",attrs:{"dataSource":_vm.chartDatas[stock.stockId],"upDowmColorConfig":_vm.upDowmColorConfig}}):_vm._e()],1)}),0)]),_vm._v(" "),(_vm.showShadow)?[_c('div',{staticClass:"shadow left"}),_vm._v(" "),_c('div',{staticClass:"shadow right"})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }